var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-view-area',[_c('iv-card',{attrs:{"label":"Form Elements"}},[_c('iv-table',{attrs:{"value":_vm.formComponents,"interface":_vm.table_inf},scopedSlots:_vm._u([_vm._l(([
                    'normal',
                    'required',
                    'defaultInvalid',
                    'stateTrue',
                    'stateFalse',
                    'disabled',
                ]),function(slotName,idx){return {key:slotName,fn:function({ $attrs }){return [($attrs.value && Array.isArray($attrs.value))?[_vm._l(($attrs.value),function(item,idx){return [_c(item.is,_vm._b({key:idx,tag:"component"},'component',item,false))]})]:_vm._e(),($attrs.value && $attrs.value.is)?_c($attrs.value.is,_vm._b({key:idx,tag:"component"},'component',{ ...$attrs.value },false)):_vm._e()]}}})],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }